module.exports = __webpack_public_path__ + "img/circle-remove.9f34c996.svg";